<template>
    <div>

        <specialist-stats
            v-if="provider.user"
            v-on:click-name="onClickName"
            :to-profile="provider.id"
            :specialist="entity"
            :ratings="true"></specialist-stats>

        <institution-stats
            v-else
            :institution="entity"
            :to-profile="provider.id"
            v-on:click-name="onClickName"
            :ratings="true"></institution-stats>

    </div>
</template>

<script>

    import SpecialistStats from '@/components/specialists/SpecialistStats'
    import InstitutionStats from '@/components/institutions/InstitutionStats'

    export default{
        components: {SpecialistStats, InstitutionStats},
        props: ['provider'],
        methods: {
            onClickName(entity){

                this.$emit('click-name', entity)
            }
        },
        computed: {
            entity(){

                var vm = this
                let entity = vm.provider.user ? vm.provider.user : vm.provider.institution
                entity.ratings_summary = vm.provider && vm.provider.ratings_summary || {
                            avg: 0,
                            count: 0,
                            last: []
                        }
                entity.settings = vm.provider.settings

                return entity


            }
        }
    }
</script>